module.exports = __webpack_public_path__ + "img/sberbank.3ccaf438.svg";